import React from 'react';
import { useTrace } from '../../context/TraceContext';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Scan, ExternalLink } from 'lucide-react';

const TraceOverlay = () => {
  const { currentRouteTrace, openTraceInspector } = useTrace();

  if (!currentRouteTrace) return null;

  return (
    <div 
      className="fixed top-20 left-72 z-50 bg-slate-900/95 backdrop-blur border border-cyan-800/50 rounded-md shadow-lg shadow-cyan-500/10 p-4 max-w-md"
      data-testid="trace-overlay"
    >
      <div className="flex items-center gap-2 mb-3">
        <Scan className="h-4 w-4 text-cyan-400" />
        <span className="text-sm font-bold text-cyan-400 tracking-wide">PID TRACE</span>
      </div>

      {/* PRD References */}
      <div className="mb-3">
        <p className="text-xs text-slate-500 uppercase tracking-wider mb-1.5">PRD References</p>
        <div className="flex flex-wrap gap-1.5">
          {currentRouteTrace.prd?.map((ref, idx) => (
            <Badge 
              key={idx}
              className="bg-cyan-950/80 text-cyan-400 border border-cyan-800 px-2 py-0.5 text-[10px] font-mono cursor-pointer hover:bg-cyan-900/80"
              onClick={() => openTraceInspector({ type: 'prd', ref })}
            >
              {ref}
            </Badge>
          ))}
        </div>
      </div>

      {/* Requirement IDs */}
      <div className="mb-3">
        <p className="text-xs text-slate-500 uppercase tracking-wider mb-1.5">Requirement IDs</p>
        <div className="flex flex-wrap gap-1.5">
          {currentRouteTrace.req?.map((reqId, idx) => (
            <Badge 
              key={idx}
              className="bg-emerald-950/80 text-emerald-400 border border-emerald-800 px-2 py-0.5 text-[10px] font-mono cursor-pointer hover:bg-emerald-900/80"
              onClick={() => openTraceInspector({ type: 'req', id: reqId })}
            >
              {reqId}
            </Badge>
          ))}
        </div>
      </div>

      {/* Notes */}
      {currentRouteTrace.notes && (
        <p className="text-xs text-slate-500 italic mb-3">
          {currentRouteTrace.notes}
        </p>
      )}

      <Button
        size="sm"
        variant="outline"
        className="w-full border-cyan-800 text-cyan-400 hover:bg-cyan-950/50 text-xs"
        onClick={() => openTraceInspector()}
        data-testid="open-trace-inspector"
      >
        <ExternalLink className="h-3 w-3 mr-2" />
        Open Trace Inspector
      </Button>
    </div>
  );
};

export default TraceOverlay;
